module.exports = __webpack_public_path__ + "img/icon-yinpin2.5b420b35.png";